import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Change dynamiquement le favicon + apple-touch-icon + le <title> selon la route.
 * - /wall → favicon WallTunes (logo carré) + titre "WallTunes"
 * - tout le reste → favicon MediaWebRadio (logo officiel) + titre marketing
 *
 * Préparation pour le futur site dédié WallTunes : il suffira de splitter
 * cette logique le jour où WallTunes aura son propre domaine.
 */
const FAVICONS = {
  walltunes: {
    icon: "/walltunes-square-logo.png",
    title: "WallTunes — Le mur de vos radios",
  },
  mediaweb: {
    icon: "/mediawebradio-logo.png",
    title: "MediaWebRadio — Radios internet professionnelles",
  },
};

function setFavicon(href) {
  // Met à jour TOUS les <link rel="icon"> et <link rel="apple-touch-icon">
  const selectors = ['link[rel="icon"]', 'link[rel="apple-touch-icon"]', 'link[rel="apple-touch-icon-precomposed"]'];
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      el.setAttribute("href", href);
    });
  });
}

export function DynamicFavicon() {
  const { pathname } = useLocation();
  useEffect(() => {
    const isWall = pathname.startsWith("/wall");
    const cfg = isWall ? FAVICONS.walltunes : FAVICONS.mediaweb;
    setFavicon(cfg.icon);
    document.title = cfg.title;
  }, [pathname]);
  return null;
}
